<script setup lang="ts">
import dayjs from 'dayjs';

const props = withDefaults(
  defineProps<{
    label: string;
    format?: string;
    disabled?: boolean;
    rules?: any;
    placeholder?: string;
    maxDate?: Date;
    minDate?: Date;
    errorMessages?: any;
    is24hr?: boolean;

    increment?: number;
  }>(),
  {
    increment: 15,
  }
);

const modelValue = defineModel();

const times = computed(() => {
  const options = [];
  // Start from 5:00 AM (5) to 5:00 PM (17) - but only show 5:00 PM, not 5:15, 5:30, 5:45 PM
  for (let i = 5; i <= 17; i++) {
    for (let j = 0; j < 60; j += props.increment) {
      // Skip times after 5:00 PM (17:00)
      if (i === 17 && j > 0) {
        break;
      }
      const hours = i < 10 ? `0${i}` : `${i}`;
      const minutes = j < 10 ? `0${j}` : `${j}`;
      const timeFormat = props.is24hr
        ? `${hours}:${minutes}`
        : `${((i + 11) % 12) + 1}:${minutes} ${i < 12 ? 'AM' : 'PM'}`;
      options.push(timeFormat);
    }
  }
  return options;
});
</script>

<template>
  <v-select
    v-model="modelValue"
    hide-details="auto"
    variant="solo-filled"
    flat
    :items="times"
    :label="label"
    :disabled="props.disabled"
    :rules="props.rules"
    :placeholder="props.placeholder"
    :error-messages="props.errorMessages"
  />
</template>
